import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import React, { memo } from 'react'

import { MediaContextProvider } from './media'

export type Theme = typeof theme

export const theme = {
  colors: {
    variants: {
      neutralLight4: '#FFFFFF',
      neutralLight3: '#F0EDEA',
      neutralLight2: '#D8D4CE',
      neutralDark4: '#2E271F',
      neutralDark3: '#39322B',
      neutralDark2: '#4A4545',
      neutralDark1: '#000000',
      primaryLight: '#AC908A',
      dangerLight: '#A3012C',
    },
  },
  fontFamily: {
    heading: "'Lora', serif",
    paragraph: "'Manrope', sans-serif",
  },
}

export const ThemeProvider = memo(function ThemeProvider({ children }: any) {
  return (
    <EmotionThemeProvider theme={theme}>
      <MediaContextProvider>{children}</MediaContextProvider>
    </EmotionThemeProvider>
  )
})
